import { Mountain, ShieldCheck } from "lucide-react";
import { LOGIN } from "../constants/testIds";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0D12] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] bg-[repeating-linear-gradient(45deg,#fff,#fff_2px,transparent_2px,transparent_14px)]" />
      <div className="w-full max-w-sm relative z-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-cyan-500/10 border border-cyan-500/40 flex items-center justify-center mb-4">
            <Mountain className="w-8 h-8 text-cyan-400" />
          </div>
          <h1 className="text-2xl font-black uppercase tracking-tight text-slate-100 text-center">
            Inspection des Fronts<br /><span className="text-cyan-400">de Carrière</span>
          </h1>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mt-2">Pilotage temps réel — Carrière</p>
        </div>
        <div className="bg-[#121820] border border-slate-800 rounded-2xl p-6 space-y-5">
          <button
            data-testid={LOGIN.submitButton}
            onClick={handleGoogleLogin}
            className="w-full h-11 rounded-md bg-white hover:bg-slate-100 text-slate-900 font-bold text-sm flex items-center justify-center gap-2.5 transition-colors"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5">
              <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.66-.22-2.44H12v4.62h6.48c-.28 1.5-1.13 2.77-2.4 3.62v3.01h3.5c2.04-1.88 3.24-4.65 3.24-8.81z" />
              <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.92l-3.5-3.01c-.98.66-2.23 1.05-3.94 1.05-3.02 0-5.58-2.04-6.5-4.78H1.9v3.09C3.85 21.3 7.63 24 12 24z" />
              <path fill="#FBBC05" d="M5.5 14.34c-.23-.66-.36-1.37-.36-2.34s.13-1.68.36-2.34V6.57H1.9C1.14 8.06.7 9.96.7 12s.44 3.94 1.2 5.43l3.6-2.09z" />
              <path fill="#EA4335" d="M12 4.75c1.76 0 3.34.6 4.58 1.79l3.1-3.1C17.95 1.5 15.24.32 12 .32 7.63.32 3.85 3.02 1.9 6.57l3.6 2.09c.92-2.74 3.48-3.91 6.5-3.91z" />
            </svg>
            Se connecter avec Google
          </button>
          <div data-testid="login-domain-restriction" className="flex items-center gap-2 justify-center text-xs font-mono uppercase tracking-widest text-slate-500">
            <ShieldCheck className="w-3.5 h-3.5 text-cyan-500" /> Accès réservé aux comptes autorisés
          </div>
        </div>
      </div>
    </div>
  );
}
